import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import event from './modules/event'
import notification from './modules/notification'

Vue.use(Vuex)
Vue.config.debug = true

const debug = process.env.NODE_ENV !== 'production'
// states
const state = {
	connect: false,
	progress: false,
	baseURL: 'https://cp.legalbis.ru',
	apiURL: 'https://cp.legalbis.ru/api',
	loggedIn: false,
	user: null,
	userAuth: null,
	funny_progress: false
}

const mutations = {
	SOCKET_CONNECT: (state, status) => {
		state.connect = true
	},
	SOCKET_DISCONNECT: (state, status) => {
		state.connect = false
	},
	TOGGLE_LOADING (state) {
		state.callingAPI = !state.callingAPI
	},
	TOGGLE_PROGRESS (state) {
		state.progress = !state.progress
	},
	CALL_API_ON (state) {
		state.callingAPI = true
	},
	CALL_API_OFF (state) {
		state.callingAPI = false
	},
	TOGGLE_SEARCHING (state) {
		state.searching = (state.searching === '') ? 'loading' : ''
	},
	SET_USER (state, user) {
		state.user = user
	},
	SET_USER_AUTH (state, userAuth) {
		state.userAuth = userAuth
		// this.commit('SET_AUTH_REFRESHING')
	},
	FUNNY_PROGRESS_ON (state) {
		state.funny_progress = true
	},
	FUNNY_PROGRESS_OFF (state) {
		state.funny_progress = false
	}
}

const actions = {
}

const modules = {
	userModule: user,
	event: event,
	notification: notification
}

export default new Vuex.Store({
	state,
	mutations,
	actions,
	modules,
	strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js